import React from "react";
import "./Card.scss";

const Card = ({ cardPadding, boxShadow, border, children, bgcolor }) => {
  return (
    <div
      className="card"
      style={{
        padding: cardPadding,
        boxShadow: boxShadow,
        border: border,
        backgroundColor: bgcolor,
      }}
    >
      {children}
    </div>
  );
};

export default Card;
